import React, { useEffect, useState } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import { MenuIcon, XIcon, ArrowRightIcon } from 'lucide-react';
import { Logo } from './Logo';
const NAV_LINKS = [{
  label: 'Inicio',
  href: '#inicio'
}, {
  label: 'Productos',
  href: '#productos'
}, {
  label: 'Nosotros',
  href: '#nosotros'
}, {
  label: 'Blog',
  href: '#blog'
}, {
  label: 'Contacto',
  href: '#contacto'
}];
export function Header() {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);
  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 12);
    onScroll();
    window.addEventListener('scroll', onScroll, {
      passive: true
    });
    return () => window.removeEventListener('scroll', onScroll);
  }, []);
  useEffect(() => {
    document.body.style.overflow = open ? 'hidden' : '';
    return () => {
      document.body.style.overflow = '';
    };
  }, [open]);
  return <header className="fixed inset-x-0 top-0 z-50" data-id="element-83" data-mp="3fc9lo0jyv05h">
      <div className={`transition-all duration-500 ${scrolled ? 'border-b border-ink/[0.07] bg-white/85 backdrop-blur-xl' : 'border-b border-transparent bg-white/40 backdrop-blur-sm'}`} data-id="element-84" data-mp="2wkkydbxg5m38">
        <div className="mx-auto flex h-[68px] w-full max-w-content items-center justify-between px-6 lg:px-8" data-id="element-85" data-mp="2mn6s2558mdon">
          <Logo data-id="element-86" data-mp="2hpenobneoz3k" />

          <nav aria-label="Navegación principal" className="hidden lg:block" data-id="element-87" data-mp="2hpy9w4k3a9ne">
            <ul className="flex items-center gap-1" data-id="element-88" data-mp="3fakgfeuve0x5">
              {NAV_LINKS.map(link => <li key={link.label} data-id="element-89" data-mp="3ad13ci9wru6s">
                  <a href={link.href} className="rounded-full px-4 py-2 text-sm text-ink-soft transition-colors duration-200 hover:bg-paper-alt hover:text-ink focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-electric/40" data-id="element-90" data-mp="35l9b83b3tgej">
                    {link.label}
                  </a>
                </li>)}
            </ul>
          </nav>

          <div className="flex items-center gap-2" data-id="element-91" data-mp="1rdbbemujwyqn">
            <a href="#productos" className="group brand-gradient-bg hidden items-center gap-2 rounded-full px-5 py-2.5 text-sm font-medium text-white shadow-[0_14px_32px_-14px_rgba(90,80,246,0.7)] transition-all duration-300 hover:brightness-105 focus-visible:outline-none focus-visible:ring-2 focus-visible:ring-electric/50 sm:inline-flex" data-id="element-92" data-mp="1rfxhei1sn66r">
              Explorar Productos
              <ArrowRightIcon aria-hidden="true" className="h-4 w-4 transition-transform duration-300 group-hover:translate-x-0.5" data-id="element-93" data-mp="1cootqehgbuw9" />
            </a>
            <button type="button" onClick={() => setOpen(v => !v)} aria-expanded={open} aria-label={open ? 'Cerrar menú' : 'Abrir menú'} className="grid h-10 w-10 place-items-center rounded-xl border border-ink/10 bg-white text-ink-soft transition-colors hover:text-ink lg:hidden" data-id="element-94" data-mp="13nz4jtmp52ri">
              {open ? <XIcon className="h-5 w-5" aria-hidden="true" data-id="element-95" data-mp="mcbtf7n43xga" /> : <MenuIcon className="h-5 w-5" aria-hidden="true" data-id="element-96" data-mp="hdgyj7bveift" />}
            </button>
          </div>
        </div>
      </div>

      <AnimatePresence data-id="element-97" data-mp="rd7s96slwteu">
        {open && <motion.div initial={{
        opacity: 0,
        y: -8
      }} animate={{
        opacity: 1,
        y: 0
      }} exit={{
        opacity: 0,
        y: -8
      }} transition={{
        duration: 0.25,
        ease: [0.22, 1, 0.36, 1]
      }} className="border-b border-ink/[0.07] bg-white/95 backdrop-blur-xl lg:hidden" data-id="element-98" data-mp="rcg7kr0jsg3c">
            <nav aria-label="Navegación móvil" className="px-6 py-6" data-id="element-99" data-mp="1f0zgn8rf8wwh">
              <ul className="space-y-1" data-id="element-100" data-mp="1a4sc9keobtgn">
                {NAV_LINKS.map(link => <li key={link.label} data-id="element-101" data-mp="3gvhyyfsnoi8f">
                    <a href={link.href} onClick={() => setOpen(false)} className="block rounded-xl px-3 py-3 text-base text-ink-soft transition-colors hover:bg-paper-alt hover:text-ink" data-id="element-102" data-mp="3gwjjdavkah2t">
                      {link.label}
                    </a>
                  </li>)}
              </ul>
              <a href="#productos" onClick={() => setOpen(false)} className="brand-gradient-bg mt-4 inline-flex w-full items-center justify-center gap-2 rounded-full px-5 py-3 text-sm font-medium text-white" data-id="element-103" data-mp="2cv0fgl121b9k">
                Explorar Productos
                <ArrowRightIcon aria-hidden="true" className="h-4 w-4" data-id="element-104" data-mp="1t8vqeqpl609a" />
              </a>
            </nav>
          </motion.div>}
      </AnimatePresence>
    </header>;
}